import { useAuth } from '@okta/okta-vue';
import errorMessages from '@/constants/errorMessagesConstants';
import useErrorsStore from '@/stores/errorStore.ts';
import type { FatalErrorSolution } from '@/types/errorTypes.ts';
import { useRouter } from 'vue-router';
import useUserStore from '@/stores/userStore.ts';

const filename = 'authenticationService.ts';

let isHandlingAuthentication = false;

function getAuthenticationService() {
  const emptyCache: FatalErrorSolution = {
    label: 'Réessayer',
    action: () => {
      const errorStore = useErrorsStore();

      localStorage.removeItem('okta-cache-storage');
      localStorage.removeItem('okta-token-storage');
      sessionStorage.removeItem('okta-token-storage');
      sessionStorage.removeItem('okta-cache-storage');

      if (errorStore.nextFatalError) {
        errorStore.removeFatalError(errorStore.nextFatalError.id);
      }

      authenticationServiceFactory.goToLandingPage();
    },
  };

  const authenticationServiceFactory = {
    async handleLoginRedirect() {
      if (!isHandlingAuthentication) {
        isHandlingAuthentication = true;

        const auth = useAuth();

        if (!(await auth.isAuthenticated())) {
          await auth.handleLoginRedirect();
        }

        isHandlingAuthentication = false;
      }
    },

    manageRedirection() {
      try {
        return authenticationServiceFactory.handleLoginRedirect();
      } catch (error) {
        const payload = {
          name: errorMessages.OKTA.TITLE,
          filename,
          message: errorMessages.OKTA.MESSAGE.toParamString(String(error)),
          solution: emptyCache,
        };
        // eslint-disable-next-line no-console
        console.error(payload);

        const errorStore = useErrorsStore();

        errorStore.addFatalError(payload);
      }
    },

    goToLandingPage() {
      const availablePages = useUserStore().user.availablePages;
      const landingPage = availablePages && availablePages[0] && availablePages[0].name;

      useRouter().push({ name: landingPage ?? '/' });
    },
  };

  return authenticationServiceFactory;
}

const authenticationService = getAuthenticationService();

export default authenticationService;
